import { cva } from 'class-variance-authority';

export const alertVariants = cva(
  'eye:relative eye:grid eye:w-full eye:grid-cols-[0_1fr] eye:items-start eye:gap-y-4xs eye:rounded-md eye:p-m',
  {
    variants: {
      variant: {
        info: 'eye:bg-blue-25 eye:[&>button]:hover:bg-blue-50',
        error: 'eye:bg-red-25 eye:[&>button]:hover:bg-red-50',
        warning: 'eye:bg-yellow-35 eye:[&>button]:hover:bg-yellow-100',
        success: 'eye:bg-green-25 eye:[&>button]:hover:bg-green-50',
      },
    },
    defaultVariants: {
      variant: 'info',
    },
  },
);
